import React from "react";
import PricingSettingsListForm from './list/PricingSettingsListForm';
import CreatePricingSettingsForm from './create/CreatePricingSettingsForm'

const PricingSettingsView = ({ displayList }) => {
  return displayList ? (
    <PricingSettingsListForm />
  ) : (
    <CreatePricingSettingsForm />
  );
};

export default PricingSettingsView;
